import { FundOpportunityEOIController } from './controller';

export function acceptInvitation(
  ctx: FundOpportunityEOIController,
  data: { firstName: string; lastName: string; mobile: string; eoiAmount?: number },
): void {
  if (!ctx.props.referrer) {
    console.error('No referrer info set');
    return;
  }

  const invitationCode = ctx.props.referrer.code;

  ctx.setState({
    acceptingInvitation: true,
    invitationAcceptError: undefined,
  });

  fetch(`/api/referral/invitation/${invitationCode}/accept`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.error || 'Failed to accept invitation');
        });
      }
      return response.json();
    })
    .then(() => {
      ctx.setState({
        acceptingInvitation: false,
        invitationAccepted: true,
      });
    })
    .catch((error) => {
      console.error('Error accepting invitation:', error);
      ctx.setState({
        acceptingInvitation: false,
        invitationAcceptError:
          error instanceof Error ? error.message : 'Failed to accept invitation. Please try again.',
      });
    });
}

export function rejectInvitation(ctx: FundOpportunityEOIController) {
  if (!ctx.props.referrer) {
    console.error('No referrer info set');
    return;
  }

  const invitationCode = ctx.props.referrer.code;

  // Call the backend API to reject the invitation
  fetch(`/api/referral/invitation/${invitationCode}/reject`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to reject invitation');
      }
      return response.json();
    })
    .then(() => {
      // Show message and redirect
      alert('Invitation declined.');
      window.location.href = '/';
    })
    .catch((error) => {
      console.error('Error rejecting invitation:', error);
      alert('Failed to decline invitation. Please try again.');
    });
}
